import React from 'react';
import { useSelector } from 'react-redux';
import { ClientRailSidebar } from './ClientRailSidebar';
import { useRailBadges } from './useRailBadges';
import { initialsOf } from '@/components/ui';

interface ClientShellProps {
  history: { push: (path: string) => void; location: { pathname: string } };
  onLogout: () => void;
  children: React.ReactNode;
}

export const ClientShell = ({
  history,
  onLogout,
  children,
}: ClientShellProps) => {
  // loggedUser.data may be {} on first render; guard like AppShell does.
  const data = useSelector((s: any) => s.loggedUser?.data) || {};
  const fullName = `${data.firstName || ''} ${data.lastName || ''}`.trim();

  const user = {
    initials: initialsOf(fullName || data.emailAddress || '?'),
    name: fullName || data.emailAddress || '',
  };

  const activePath = history.location.pathname || '/';

  const { messages, notifications } = useRailBadges();
  const counts: Record<string, number> = { messages, notifications };

  return (
    <div className="tw-flex tw-flex-row tw-h-screen tw-w-full tw-overflow-hidden">
      <ClientRailSidebar
        activePath={activePath}
        onNavigate={(path) => history.push(path)}
        onLogout={onLogout}
        user={user}
        counts={counts}
      />
      <div className="tw-flex tw-flex-col tw-flex-1 tw-min-w-0 tw-h-full">
        <div className="tw-flex-1 tw-min-h-0 tw-overflow-auto tw-bg-white">
          {children}
        </div>
      </div>
    </div>
  );
};
